<div class="tracking-page-preview-container">
  <pdq-card variant="popover" color="white">
    <div class="card">
      <div class="card__header">
        <pdq-heading element="h5">Preview</pdq-heading>
      </div>
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <div class="tracking-page-preview">
          @if (widgets.couponCodes.length && couponCodeIndexToPreview >= 0) {
            <div class="coupon-code-widget-wrapper" [style.background-color]="accentColor">
              <div class="coupon-code">
                @if (widgets.couponCodes[couponCodeIndexToPreview]?.title) {
                  <div class="coupon-code__title">
                    {{ widgets.couponCodes[couponCodeIndexToPreview].title }}
                  </div>
                }
                @if (widgets.couponCodes[couponCodeIndexToPreview]?.description) {
                  <div>
                    {{ widgets.couponCodes[couponCodeIndexToPreview].description }}
                  </div>
                }
                <div class="coupon-code__value">
                  <div>EC2DIS</div>
                  <div>Copy code</div>
                </div>
              </div>
            </div>
          }

          <div>
            @if (
              widgets?.details?.displayMessageForUntrackedShipments &&
              widgets?.details?.messageForUntrackedShipments &&
              widgets?.details?.showTrackingDetails
            ) {
              <div class="untracked-shipment-container">
                <div class="untracked-shipment-container__head">
                  <div class="untracked-shipment">
                    <pdq-icon size="x-large" icon="more_information"></pdq-icon>
                    <div [style.font-weight]="500">{{ widgets.details.messageForUntrackedShipments }}</div>
                  </div>
                </div>
              </div>
            }

            @if (
              widgets?.details?.displayMessageWhenHandedOverToDifferentCarrier &&
              widgets?.details?.messageWhenHandedOverToDifferentCarrier &&
              widgets?.details?.showTrackingDetails
            ) {
              <div class="untracked-shipment-container">
                <div class="untracked-shipment-container__head">
                  <div class="untracked-shipment">
                    <pdq-icon size="x-large" icon="more_information"></pdq-icon>
                    <div [style.font-weight]="500">{{ widgets.details.messageWhenHandedOverToDifferentCarrier }}</div>
                  </div>
                </div>
              </div>
            }

            <div [style.color]="'var(--on-surface-light)'">Order #876578</div>
            @if (widgets?.simpleTracker.showTrackingProgress) {
              <div class="tracking-status-stepper" [style.--accent-color]="accentColor">
                <div
                  class="label"
                  [ngStyle]="{
                    color: unsuccessfulTrackingStatusColorPreviewButtonState
                      ? widgets?.simpleTracker?.unsuccessfulTrackingStatusColor
                      : 'var(--on-surface-light)',
                    left: unsuccessfulTrackingStatusColorPreviewButtonState ? '94%' : '25%',
                  }">
                  {{ currentTrackingStatusStepIndex === 1 ? 'Picked up by carrier' : 'Failed' }}
                </div>
                <!-- Active line spanning completed steps -->
                <div
                  class="active-line"
                  [ngStyle]="{
                    width: (currentTrackingStatusStepIndex / (trackingHistory.length - 1)) * 100 + '%',
                  }"></div>
                <div
                  class="active-line"
                  [ngStyle]="{
                    'background-color': unsuccessfulTrackingStatusColorPreviewButtonState
                      ? widgets?.simpleTracker?.unsuccessfulTrackingStatusColor
                      : 'var(--accent-color, #00796b)',
                    width: unsuccessfulTrackingStatusColorPreviewButtonState
                      ? 100 - (3 / (trackingHistory.length - 1)) * 100 + '%'
                      : '20%',
                    left: unsuccessfulTrackingStatusColorPreviewButtonState
                      ? (3 / (trackingHistory.length - 1)) * 100 + '%'
                      : '0%',
                  }"></div>
                @for (row of trackingHistory; track row; let idx = $index) {
                  <div class="step">
                    <div
                      class="circle"
                      [ngClass]="{
                        completed: idx <= currentTrackingStatusStepIndex,
                        active: idx === currentTrackingStatusStepIndex,
                      }"
                      [ngStyle]="{
                        visibility:
                          widgets?.simpleTracker?.showFutureSteps || idx <= currentTrackingStatusStepIndex
                            ? 'visible'
                            : 'hidden',
                        'background-color':
                          idx === trackingHistory.length - 1
                            ? unsuccessfulTrackingStatusColorPreviewButtonState
                              ? widgets?.simpleTracker?.unsuccessfulTrackingStatusColor
                              : '#e0e0e0'
                            : undefined,
                        'border-color':
                          idx === trackingHistory.length - 1
                            ? unsuccessfulTrackingStatusColorPreviewButtonState
                              ? widgets?.simpleTracker?.unsuccessfulTrackingStatusColor
                              : '#e0e0e0'
                            : undefined,
                      }"></div>
                  </div>
                }
                <div
                  class="date"
                  [style.color]="'var(--on-surface-light)'"
                  [ngStyle]="{
                    left: unsuccessfulTrackingStatusColorPreviewButtonState ? '85%' : '20%',
                  }">
                  June 4
                </div>
              </div>
            }
            @if (widgets?.details?.showDeliveryStatus && widgets?.details?.showTrackingDetails) {
              <div>
                <pdq-heading element="h1">
                  {{
                    unsuccessfulTrackingStatusColorPreviewButtonState ? 'Delivery Failed' : 'Your order is on the way'
                  }}
                </pdq-heading>
              </div>
            }
          </div>

          @if (widgets?.details?.showTrackingDetails) {
            <div class="shipment">
              @if (
                widgets?.deliveryPromise?.showShippingMethodPromise &&
                !unsuccessfulTrackingStatusColorPreviewButtonState
              ) {
                <div class="shipment__head">
                  <div class="delivery-estimation">
                    @if (widgets?.deliveryPromise?.showExpectedLateIndicator) {
                      <div [style.display]="'flex'" [style.flex-direction]="'column'" [style.gap]="'4px'">
                        <div [style.font-size]="'18px'" [style.font-weight]="'600'">
                          Expected Arrival: Tuesday, Jan 8
                        </div>
                        <div [style.font-size]="'13px'" [style.font-weight]="'500'">
                          Originally promised: Sunday, Jan 6
                        </div>
                      </div>
                      <div
                        [style.color]="accentColor"
                        [style.background-color]="'#FFFFFF'"
                        [style.border-radius]="'20px'"
                        [style.padding]="'3px 6px'">
                        Expected Late
                      </div>
                    } @else {
                      <div [style.font-size]="'18px'" [style.font-weight]="'600'">Arrives Sunday, Jan 6</div>
                      <div
                        [style.color]="accentColor"
                        [style.background-color]="'#FFFFFF'"
                        [style.border-radius]="'20px'"
                        [style.padding]="'3px 6px'">
                        Late 🫣
                      </div>
                    }
                  </div>
                </div>
              } @else if (
                widgets?.deliveryPromise?.showCarrierETA && !unsuccessfulTrackingStatusColorPreviewButtonState
              ) {
                <div class="shipment__head">
                  <div class="delivery-estimation">
                    <div [style.font-size]="'18px'" [style.font-weight]="'600'">Arrives by Tuesday, Jan 8</div>
                  </div>
                </div>
              }
              @if (widgets?.details?.displayTrackingNumber) {
                <div class="shipment__divider"></div>
              }
              @if (widgets?.details?.displayTrackingNumber) {
                <div class="shipment__content" [style.border-radius]="'0px'">
                  <span>UPS</span>
                  <span
                    [style.color]="accentColor"
                    [style.display]="'flex'"
                    [style.gap]="'4px'"
                    [style.align-items]="'center'"
                    >120987656789876 <pdq-icon size="size" icon="go_to_order" [color]="accentColor"></pdq-icon
                  ></span>
                </div>
              }
              <div class="shipment__divider"></div>
              @if (widgets?.details?.showDetailedTrackingHistory) {
                <div class="shipment__content">
                  <div class="tracking-history">
                    <div class="stepper-container">
                      <ul class="tracking-history-list">
                        @for (
                          row of trackingHistory | slice: 0 : maxNumOfTrackingHistoryRows;
                          track row;
                          let i = $index
                        ) {
                          <li>
                            <ng-container>
                              @if (i == 0) {
                                <tracking-page-stepper-arrow [colorHex]="'#000000'"></tracking-page-stepper-arrow>
                              } @else {
                                <span></span>
                              }
                              <div [style.font-weight]="500">
                                {{
                                  i === 0 && unsuccessfulTrackingStatusColorPreviewButtonState
                                    ? 'Failed to deliver'
                                    : row.status
                                }}
                              </div>
                              <div [style.color]="'var(--on-surface-light)'">{{ row.location }} - {{ row.date }}</div>
                            </ng-container>
                          </li>
                        }
                      </ul>
                      @if (trackingHistory.length > maxNumOfTrackingHistoryRows) {
                        <div class="more_updates">
                          <div class="action" [style.color]="accentColor">See more updates</div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          }

          @if (widgets?.productSection?.showProductSection) {
            <div class="card line-items">
              <div class="line-items-header">
                <div class="line-items__title">
                  <div [style.font-size]="'18px'" [style.font-weight]="'600'">{{ widgets.productSection?.title }}</div>
                </div>
              </div>
              <hr class="divider" />
              <div class="line-items-list">
                @for (row of lineItems; track row) {
                  <div class="product-item">
                    <div class="thumbnail">
                      <img [src]="defaultImage" alt="" />
                    </div>
                    <div class="product-details">
                      <div class="product-name" [style.font-weight]="500">{{ row.name }} x {{ row.quantity }}</div>
                      <div class="product-detail" [innerHTML]="formatBodyText(widgets.productSection?.bodyText)"></div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          @if (showDestinationMap) {
            <div class="map-container">
              <tracking-page-marker [colorHex]="accentColor"></tracking-page-marker>
              <img width="100%" src="/assets/images/tracking-page/map-example.svg" />
            </div>
          }
        </div>
      </div>
    </div>
  </pdq-card>
</div>
